import { inject, Injectable } from '@angular/core';
import { EMPTY, defer, expand, map, reduce, type Observable } from 'rxjs';

import { EntriesService } from '../../../features/admin/modules/features/entries/entries.service';
import type { Entry, Module } from '../../../features/admin/modules/modules.model';

export interface ReviewDocumentsQuery {
  moduleId: Module['id'];
  filter: string;
  pageSize?: number;
}

interface ReviewDocumentsPage {
  entries: Entry[];
  offset: number;
}

@Injectable({ providedIn: 'root' })
export class ReviewDocumentsQueryService {
  readonly #entriesService = inject(EntriesService);

  loadAll(query: ReviewDocumentsQuery): Observable<readonly Entry[]> {
    const pageSize = query.pageSize ?? 50;
    const loadPage = (offset: number) =>
      this.#entriesService
        .getEntries({
          moduleId: query.moduleId,
          offset,
          limit: pageSize,
          filter: query.filter,
          orderBy: { active: 'id', direction: 'asc' },
          applyQueryParams: false,
        })
        .pipe(map(entries => ({ entries, offset }) satisfies ReviewDocumentsPage));

    return defer(() => loadPage(0)).pipe(
      expand(page => (page.entries.length === pageSize ? loadPage(page.offset + pageSize) : EMPTY)),
      reduce((all, page) => [...all, ...page.entries], [] as Entry[])
    );
  }
}
